/* @flow */
import AdminSisSyncHoldView from './AdminSisSyncHoldView';

export default AdminSisSyncHoldView;
